export default __webpack_public_path__ + "static/media/ep-rectangle.259dab68.svg";